export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-chord/src/array.js
// module id = 235
// module chunks = 0 1 2 3 4